<template>
  <div id="app">
    <el-container class="top container">
        <el-header>
          <el-row>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="center">
              <div class="grid-content bg-purple logo"></div>
            </el-col>
            <!-- <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="hidden-sm-and-down">
              <vue-seamless-scroll :data="listData" class="seamless-warp" :class-option="classOption">
                <ul class="item">
                    <li v-for="(item,index) in listData" :key="index">
                        <div v-html="item.title"></div>
                    </li>
                </ul>
              </vue-seamless-scroll>
            </el-col> -->
          </el-row>
        </el-header> 
    </el-container>
    <div class="index-nav nav_menu container">
      <div class="index-nav-frame clearfix">
        <!-- logo -->
        <div
          class="nav-small"
          tabindex="-1"
          @click="onMnav"
          v-if="!isgzh"
        >
          <div
            class="nav-small-focus"
            tabindex="-1"
            v-if="isgzhl != 2"
          ></div>
          <img src="../assets/images/icon.png" v-if="isgzhl != 2" />
        </div>
        <div class="leftfloat dataMenu hidden-sm-and-down">{{ dataMenu }}</div>
        <div
          v-for="(item, index) in NavList"
          :key="index"
          class="index-nav-frame-line pclist"
        >
          <span @click="$router.push(item.path)">{{
            item.name
          }}</span>
          <span v-if="item.children" class="rotator">
            <img src="../assets/images/down.png" />
          </span>
          <div
            v-if="item.children"
            class="index-nav-frame-line-center"
            :class="'list' + index"
          >
            <div
              class="index-nav-frame-line-li"
              :class="'list' + index + '' + i"
              v-for="(val, i) in item.children"
              :key="i"
            >
              <span @click="$router.push(val.path)">{{
                val.name
              }}</span>
            </div>
          </div>
          <div class="index-nav-frame-line-focus"></div>
        </div>
        <div class="left english hidden-sm-and-down">
          <a :href="Url">Chinese</a>
        </div>
        <div v-if="ismnav" ref="treeWrap">
          <div
            v-for="(items, indexs) in MNavList"
            :key="10 + indexs"
            class="index-nav-frame-line mobList index-nav-frame-linem"
            @click="topath(items.path)"
          >
            <span>{{ items.name }}</span>
          </div>
          <div class="left english">
            <a :href="Url">Chinese</a>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import Search from "./Home/Search";
// 滚动列表
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: "CommonHearde",
  components: {
    Search,
  },
  data() {
    return {
      isycb: false,
      ismnav: false,
      isgzhl: 0,
      islang: true,
      NavList: [
        { name: "Home", path: "/" },
        { name: "About Journal", path: "",
           children: [
             { name: "Introduction", path: "/FixedBody?ItemId=11" },
             { name: "Editoral Board ", path: "/FixedBody?ItemId=1501" },
           ]
        },
        // { name: "Archives", path: "",
        //   children: [
        //       { name: "Current Issue", path: "/OAList?IssueId=-1" },
        //       { name: "Article Search", path: "/AdvancedSearch" },
        //       { name: "All Issues", path: "/dlistnum" },
        //       {
        //         name: "Download Ranking",
        //         path: "/DownloadlistViewlist?Key=ReadRank",
        //       },
        //       {
        //         name: "Browsing Ranking",
        //         path: "/DownloadlistViewlist?Key=ViewRank",
        //       },
        //   ]
        // },
        { name: "News", path: "/NewsList?ColumnId=8"},
        { name: "Awards", path: "/NewsList?ColumnId=9"},
        { name: "Contact us",
          children:[
            { name: "Address", path: "/FixedBody?ItemId=51"},
            { name: "Subscription", path: "/FixedBody?ItemId=3601"}
          ]
        }
      ],
      MNavList: [
        { name: "Home", path: "/" },
        { name: "Introduction", path: "/FixedBody?ItemId=11" },
        { name: "Editoral Board ", path: "/FixedBody?ItemId=1501" },
        { name: "News", path: "/NewsList?ColumnId=8"},
        { name: "Awards", path: "/NewsList?ColumnId=9"},
        { name: "Address", path: "/FixedBody?ItemId=51"},
        { name: "Subscription", path: "/FixedBody?ItemId=3601"}
      ],
      dataMenu:'',
      listData:[
        {
          title:'Cambridge Scientific Abstracts(CSA)'
        },
        {
          title:'Chemical Abstracts(CA)'
        },
        {
          title:'Abstracts Journal(AJ)'
        },
        {
          title:'Index of Copurnicus(IC)'
        },
        {
          title:'A Core Journal of A Guide to Core Journals of China'
        },
        {
          title:'A Core Journal of CSTPGD'
        },
      ]
    };
  },
  props: ["isgzh"],
  created() {
    function getDateWeek()
      {
      var todayDate = new Date();
      var date = todayDate.getDate();
      var month= todayDate.getMonth() +1;
      var year= todayDate.getYear();
      var dateweek = "";
      if(navigator.appName == "Netscape")
      {
        dateweek = dateweek + (1900+year) + "-" + month + "-" + date + " ";
      }
      if(navigator.appVersion.indexOf("MSIE") != -1)
      {
        dateweek = dateweek + year + "-" + month + "-" + date + " ";
      }
      switch(todayDate.getDay())
      {
      case 0:dateweek += "Sunday";break;
      case 1:dateweek += "Monday";break;
      case 2:dateweek += "Tuesday";break;
      case 3:dateweek += "Wednesday";break;
      case 4:dateweek += "Thursday";break;
      case 5:dateweek += "Friday";break;
      case 6:dateweek += "Saturday";break;
      }
      return dateweek;
      }
    this.dataMenu = getDateWeek()
    if (sessionStorage.getItem("SetItem")) {
      let SetItem = JSON.parse(sessionStorage.getItem("SetItem"));
      SetItem.map((item) => {
        if (item.SetItemID == 4530) {
          item.Item_Value == "是" ? (this.isycb = true) : (this.isycb = false);
        }
        if (item.SetItemID == 2900) {
          item.Item_Value == "是"
            ? (this.islang = true)
            : (this.islang = false);
        }
      });
    }
  },
  components:{vueSeamlessScroll},
  mounted() {
    let _this = this;
    if (this.$route.query) {
      this.isgzhl = this.$route.query.isgzh;
    }
    document.addEventListener("mouseup", (e) => {
      let tree = this.$refs.treeWrap;
      if (tree) {
        if (!tree.contains(e.target)) {
          this.ismnav = false;
        }
      }
    });
  },
  computed: {
      classOption () {
          return {
              step: 0.3, // 数值越大速度滚动越快
          }
      }
  },
  methods: {
    onMnav() {
      if (this.ismnav) {
        this.ismnav = false;
      } else {
        this.ismnav = true;
      }
    },
    topath(url) {
      this.$router.push(url);
      this.ismnav = false;
    },
  },
};
</script>
<style scoped>
.index-nav-frame-linem a {
  width: 100%;
  display: inline-block;
}
@media (max-width: 768px) {
  .language {
    background: #565656;
    width: 100%;
    padding: 0 0 0 8px;
    
  }
  .quick {
    margin-top: -40px !important;
  }
}
.included{ height: 120px; overflow: hidden;}
.included li{ font-size:13px; color: #ab0000; line-height: 24px;text-shadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;font-weight: bold;}


#box{
    width: 100%;
    height: 120px;
    overflow: hidden;
    padding-left: 15%;
    margin-top: 8%;
}
.anim{
    transition: all 0.5s;
    margin-top: -30px;
}
#con1 li{
     font-size:14px; color: #ab0000; line-height: 24px;text-shadow: -1px 0 #fff, 0 1px #fff, 1px 0 #fff, 0 -1px #fff;font-weight: bold;
}
.language,.language a{display: inline-block; color: #333;font-size: 16px;padding: 0 15px;  font-weight: 600;}
.language a:hover{ background: #0056ad; color: #fff; }
.top_right{ text-align: right; margin-top: 3%;}
.top{position: relative;}
.include{position: absolute; z-index: 999; bottom: -160%; left: 2%;}
.include p{ font-size: 15px; color: #ffcc00; line-height: 28px;}
.dataMenu{ color: #111; padding: 0 45px; font-size: 16px;}
.english a{padding: 0 20px; font-size: 16px; color: #111;}
.english a:hover{ display: inline-block; background: #0f6f29; color: #333;}
.item li{color: #fff; font-size: 13px; font-weight: bold; line-height: 22px; float: left; width: 100%;}
.seamless-warp {
      height: 110px;
      overflow: hidden;
      margin-top: 25px;
  }
@media (max-width:988px) {
  .english{ background: #dedede; width: 100%; padding:0}
  .english a{color: #111;}
}
</style>
